import { type FC } from "react";

import { Control, Skeleton } from "@snapchat/snap-design-system";

import { formatMediumDate } from "../../camkit/common/formatters";
import { Flexbox } from "../../shared/components";
import { detailsControl } from "../../shared/styles";
import { useReleaseNotes } from "../hooks";
import { NoReleaseNotes, ReleaseNotesError, ReleaseNotesTitle } from "../messages.generated";

interface LensReleaseNotesProps {
    lensId: string;
}

export const LensReleaseNotes: FC<LensReleaseNotesProps> = ({ lensId }) => {
    const { releaseNotes, loading, error } = useReleaseNotes({ lensId });

    if (loading) {
        return <Skeleton paragraph={5} />;
    }

    return (
        <Control label={<ReleaseNotesTitle />} className={detailsControl}>
            {releaseNotes.length === 0 ? (
                <NoReleaseNotes />
            ) : (
                <Flexbox flexDirection="column" gap="5px">
                    {releaseNotes.map((releaseNote) => {
                        const dateStr = formatMediumDate(releaseNote.date);
                        return (
                            <Flexbox key={releaseNote.id} alignItems="center" justifyContent="start">
                                <Flexbox width="30%">{dateStr}</Flexbox>
                                <Flexbox>{releaseNote.note}</Flexbox>
                            </Flexbox>
                        );
                    })}
                </Flexbox>
            )}
            {error && (
                <span>
                    <ReleaseNotesError />
                </span>
            )}
        </Control>
    );
};
